import { useTenantApi } from '@/account/hook/useTenantApi';
import { type Registration, loadRegistration, registrationQueryKey } from '@/api/registration';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from './useUserSession';

export function useRegistrationQuery(eventId: string, options: { enabled?: boolean } = { enabled: true }) {
  const { createTenantApiRequest, isLoading: isApiPreparing } = useTenantApi();
  const { userSession, setUserSession } = useUserSession();
  return useQuery<Registration, Error>({
    queryKey: [registrationQueryKey, { eventId }, { token: userSession?.authToken }],
    queryFn: async (): Promise<Registration> => {
      if (userSession?.email === undefined) {
        throw new Error('Registration query cannot be called without email from user session.');
      }
      const response = await loadRegistration(createTenantApiRequest)({ email: userSession.email, eventId });

      if (response.status === 'unauthorized') {
        setUserSession(undefined);
      }

      if (!response.item) {
        throw new Error('No registration found for this user.');
      }
      return response.item;
    },
    enabled: !isApiPreparing && !!userSession?.email && options.enabled,
  });
}
